import {Component, Optional} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockTakeReportModel} from "./stock-take-report.model";
import {FUIStackedPageContextService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-stock-take-report",
    templateUrl: "./stock-take-report.component.html",
    providers: [provideReportModel(StockTakeReportModel)]
})
export class StockTakeReportComponent extends AbstractReportPage {
    constructor(public model: StockTakeReportModel, @Optional() stackedPageContextService: FUIStackedPageContextService) {
        super();
        if (stackedPageContextService) {
            this.model.data.stockTakeId = stackedPageContextService.params["stockTakeId"];
        }
    }
}
